// extracted by mini-css-extract-plugin
export default {"productCarousel":"gZ-z"};